/* 🤖 this file was generated by svg-to-ts */
export const DfIconCross12: {
  name: 'cross-12';
  data: string;
} = {
  name: 'cross-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="m7.559 6 2.118 2.118a1.102 1.102 0 1 1-1.559 1.56L6 7.558 3.882 9.677a1.102 1.102 0 1 1-1.56-1.559L4.442 6 2.323 3.882a1.102 1.102 0 1 1 1.559-1.56L6 4.442l2.118-2.118a1.102 1.102 0 1 1 1.56 1.559L7.558 6z" fill-rule="evenodd"/></svg>`
};
